<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import moment from 'moment';

export default {
    page: {
        title: "Customers Refund",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            dtKey:0,
            key: '',
            title: "Customers Refund",
            items: [
                {
                    text: "Finance",
                    href: "/",
                },
                {
                    text: "Customers Refund",
                    href: "/",
                },
            ],

            refundList:[],
            loadingDetail:true,
            loadingUpload:false,
            ButtonSeen:true,
            PLG_filename:'',
        };
    },

    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
            }
        },

        getRefundList(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'refund/list')
            .then(response => {
                if (response) {
                    this.loadingDetail=false;
                    this.refundList = response.data;
                    this.dtKey +=1;
                    console.log(this.refundList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        downloadPLGFile: function (filename) {
            location.href= process.env.VUE_APP_API_BASEURL+'refund/download/'+filename;
        },

        submitFile()
        {
            this.loadingUpload=true;
            let formData = new FormData();
            formData.append('sourceFile', this.sourceFile);
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'refund/generatePLG_file',
                formData,
                {
                    headers: {
                        'Content-Type':'multipart/form-data'
                    }
                }
            ).then(response => {
                if (response) {
                    this.getRefundList();
                    this.loadingUpload=false;
                    console.log(response);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        handleFileUpload(){
            this.sourceFile = this.$refs.sourceFile.files[0];
        }
    },

    components: {
        Layout,
        PageHeader,
        DataTable,
    },

    mounted() {
        this.getRefundList();
        //this.get_country();
    },
    
};
require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <div class="card">
            <div class="card-body">
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        
                        <div class="card-body border-bottom-dashed border-bottom">
                           
                            <div class="row g-3">
                                <div class="col-xl-6">                  
                                    <input class="form-control" type="file" ref="sourceFile" v-on:change="handleFileUpload()">
                                </div>
                                <!--end col-->
                                <div class="col-xl-6">
                                <div class="row g-6">
                                    <div class="col-sm-4">
                                    <button v-on:click="submitFile()" class="btn btn-success w-100">
                                        <i class="ri-equalizer-fill me-2 align-bottom"></i>Generate PLG
                                        </button>
                                    </div>

                                    <div class="col-sm-8">
                                    <div>
                                        
                                    </div>
                                    </div>
                                    <!--end col-->
                                </div>
                                </div>
                            </div>
                            <!--end row-->
                            
                            <br><br>
                        </div>
                        <div class="col-lg-12">
                            <div class="pt-4">
                                <h4 class="card-title">File Upload History</h4>                           
                            </div>
                            <div v-if='loadingDetail'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="table-responsive">
                                <DataTable :options="{lengthChange: false}" :key="dtKey" class="table table-striped table-nowrap mb-0" id="example"> 
                                     <thead class="table-secondary">
                                        <tr>
                                            <th>No.</th>
                                            <th >Filname</th>      
                                            <th >Created Date</th>      
                                            <th >Created By</th>
                                            <th >PLG File</th>
                                            
                                            <!--th scope="col">Action</th-->
                                        </tr>
                                    </thead>

                                    <tbody>          
                                                     
                                        <tr v-for="(item, index) in refundList" :key="index" class="content">
                                            <td>{{ index+1 }}</td>                               
                                            <td>{{ item.filename_before }}</td>
                                            <td>{{ format_date(item.created_at) }}</td>
                                            <td>{{ item.user_name }}</td>
                                            <td>
                                                <button @click="downloadPLGFile(item.PLG_filename)" class="btn btn-secondary btn-sm"><i class="ri-file-excel-2-line align-middle me-1"></i> Download File</button>
                                            </td>
                                                   
                                        </tr>
                                    </tbody>
                                </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </Layout>
</template>